module.exports = __webpack_public_path__ + "static/media/service-block-3@3x.69b600e7.jpg";